import React from 'react'
import styled from 'styled-components'
import { Text, Button, getPaletteColor } from 'pcln-design-system'
import { WarningOutline } from 'pcln-icons'

import { Overlay } from '../../../common-components'

const OverlayBody = styled.div`
  max-width: 730px;
  color: ${getPaletteColor('text.lightest')};
  font-size: 20px;
  text-align: center;
`

const ErrorOverlay = ({ onClose }) => {
  const errorOverlayContent = (
    <OverlayBody>
      <div>
        <WarningOutline name='warningOutline' size={48} color='alert.light' />
      </div>
      <Text.p mt={30} mb={30}>
        We were unable to book the flight you selected, but we&apos;ve got more great options for you to
        choose from!
      </Text.p>
      <div>
        <Button size='large' onClick={onClose}>
          Choose New Flight
        </Button>
      </div>
    </OverlayBody>
  )

  return (
    <React.Fragment>
      <Overlay
        content={errorOverlayContent}
        backgroundColor='transparent'
        hideHeader={true}
        hideFooter={true}
        onClose={onClose}
      />
    </React.Fragment>
  )
}

export { ErrorOverlay }
